import { defineStore } from 'pinia'
import { getAllStoreList } from '@/api/common'
import { currentLocalGMTZone } from '@/utils/timeZone'
import { getBindStore } from '@/api/settings'
export interface IStoreItem {
  name: string
  id: number
}

export interface IStoreState {
  stores: IStoreItem[]
}

const updateStoreInfo = (storeCode: any) => {
  if (!storeCode) {
    return
  }
  getBindStore(storeCode)
    .then((res) => {
      if (res.success) {
        useStoreStore().setCurrentStoreTimeZone(res.data.timeZone)
      }
    })
    .catch(() => {})
}

const useStoreStore = defineStore('store', {
  state: () => ({
    stores: [],
    currentStoreId: null,
    currentStoreName: null,
    currentSotreTimeZone: null // 当前店铺时区
  }),
  getters: {},
  actions: {
    async getStoresData() {
      // 获取 店铺数据
      await getAllStoreList().then((res) => {
        this.stores = res.data
        this.currentStoreId = res?.data[0]?.storeCode || null
        this.currentStoreName = res?.data[0]?.storeName || null

        updateStoreInfo(this.currentStoreId)
      })
    },
    getCurrentStoreName() {
      return this.currentStoreName || ''
    },
    setCurrentStoreId(id: string) {
      this.currentStoreId = id
      this.currentStoreName =
        this.stores.find((item: any) => item.storeCode === id)?.storeName ||
        null
    },
    updateCurrentStoreId(id: string, name: string, timeZone: string) {
      this.currentStoreId = id
      this.currentStoreName = name
      this.currentSotreTimeZone = timeZone
    },
    async getCurrentStoreId() {
      return this.currentStoreId
    },
    async getCurrentStoreTimeZone() {
      const tz = this.currentSotreTimeZone || currentLocalGMTZone()

      return tz
    },
    async setCurrentStoreTimeZone(timeZone: string) {
      this.currentSotreTimeZone = timeZone
    },
    addStore(store: IStoreItem) {
      this.stores.push(store)
    },
    updateStores() {
      getAllStoreList().then((res) => {
        this.stores = res.data
      })
    },
    clearStores() {
      this.stores = []
      this.currentStoreId = null
      this.currentStoreName = null
      this.currentSotreTimeZone = null
      useStoreStore().$reset()
    }
  },
  persist: true
})

export default useStoreStore
